export const APPARATUS = [
  { value: 'TRA', label: 'Trampoline' },
  { value: 'DMT', label: 'Double Mini' },
  { value: 'TUM', label: 'Tumbling' },
];

export const STATUS = {
  WORKING_ON: { label: 'Working on', badge: 'badge-info' },
  COMP_READY: { label: 'Competition ready', badge: 'badge-success' },
  RETIRED: { label: 'Retired', badge: 'badge-secondary' },
};
